import { DefaultOptionType } from 'antd/es/select';

const useServiceScope = (serviceScopeId: string | null, products?: DefaultOptionType[]) => {
  const product = products?.find((product) => product.details.ID.toString() === serviceScopeId);
  const serviceScope = product?.details.service_scope ?? '';
  const serviceScopeTitle = product?.details.name ?? '';

  return { serviceScopeTitle, serviceScope };
};

export default useServiceScope;
